import React from "react";
import "./Activity.css";
import Usersiconimg from "../../image/users.svg";
import Activityid from "./sub-Activity/Activityid";
import ActualEmp from "./sub-Activity/ActualEmp";
import EmpEquipment from "./sub-Activity/EmpEquipments";
import Allowable from "./sub-Activity/Allowable";
import Executive from "./sub-Activity/Executive";

function Activity() {
  return (
    <div className="container activitymain">
      <div className="row">
        {/* start logo section */}
        <div className="col-1">
          <div className="userlogo">
            <img src={Usersiconimg} alt="" className="userlogoicon" />
          </div>
        </div>

        <div className="col-11">
          <div className="usersearchsec">
            <form action="">
              <input placeholder="Project Name" className="projectname" />
            </form>
          </div>

          <div className="row">
            < Activityid />
            < ActualEmp />
            <EmpEquipment />
            <Allowable />
            <Executive />
          </div>     

        </div>
        {/* End logo section */}
        
      </div>
    </div>
  );
}

export default Activity;
